export default function MaintenanceHistoryDetailsController($scope, $stateParams, $q, MaintenanceService, gettextCatalog) {

  'ngInject';

  var vm = this;
  vm.$onInit = function () {
    refresh();
  };

  $scope.expandArrowClicked = function (id) {
    for (var i = 0; i < $scope.tasks.length; i++) {
      if ($scope.tasks[i].id === id) {
        $scope.tasks[i].isSelected = true;
      }
    }
  };

  $scope.downArrowClicked = function (id) {
    for (var i = 0; i < $scope.tasks.length; i++) {
      if ($scope.tasks[i].id === id) {
        $scope.tasks[i].isSelected = !$scope.tasks[i].isSelected;
      }
    }
  };

  $scope.loading = true;
  var refresh = function () {
    function handleError(error) {
      var errorMsg = gettextCatalog.getString("An error occurred while retrieving maintenance history data");
      if (error.data || error.status) {
        if (error.data.message) {
          errorMsg = error.data.message + " " + (error.status.toString());
        } else {
          errorMsg += ": " + (error.status.toString());
        }
      } else {
        errorMsg += gettextCatalog.getString(". Please try again later.");
      }
      $scope.onLoadErrorFlag = true;
      $scope.onLoadErrorText = errorMsg;
      $scope.loading = false;
      return $q.reject();
    }

    $scope.loading = true;

    MaintenanceService.getServiceRecord($stateParams.id).then(function (response) {

      $scope.record = response.data;
      $scope.planData = response.data.plan;
      $scope.assetData = response.data.equipment;

      var planDataPromise = MaintenanceService.getServiceRecordTasks($stateParams.id);
      var planTasksPromise = MaintenanceService.getPlanTasks($scope.planData.id);

      return $q.all([planDataPromise, planTasksPromise]);
    }).then(function (response) {
      $scope.tasks = [];
      $scope.completedTasks = response[0].data;

      //lets merge the completed task with the plan task for all properties
      //inputs belongs to each object, in the case for a completed task its {key, value}
      response.forEach(function (entry) {
        entry.data.forEach(function (entryData) {
          var completed = _.filter($scope.completedTasks, function (ct) {
            return ct.taskId === entryData.id;
          });

          if (completed.length !== 0) {
            $scope.tasks.push(angular.extend(entryData, {
              _inputs: completed[0].inputs
            }));
          }

        });
      });

      $scope.loading = false;
    }).catch(handleError);
  };
}